import { render } from "./TrendingTournaments.vue?vue&type=template&id=ab6ccf8c&scoped=true&ts=true"
import script from "./TrendingTournaments.vue?vue&type=script&lang=ts"
export * from "./TrendingTournaments.vue?vue&type=script&lang=ts"

import "./TrendingTournaments.vue?vue&type=style&index=0&id=ab6ccf8c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab6ccf8c"]])

export default __exports__